import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { AuthenticationService } from './authentication.service';
import { map } from 'rxjs/operators';
import { getResolvedUrl } from '../../core/util/route-utils';
import { StorageService } from '../../core/util/storage.service';
import { MtnAccessToken } from './mtn-access-token';
import { LicenseType } from '../authorization/license-type.enum';

@Injectable({
  providedIn: 'root'
})
export class IsAuthenticatedStandardLicenseGuard {

  constructor(private authenticationService: AuthenticationService,
              private router: Router,
              private storageService: StorageService) {
  }

  canActivate(next: ActivatedRouteSnapshot): Observable<boolean | UrlTree> {
    return this.storageService.get(StorageService.AUTH_TOKEN)
      .pipe(map((cachedToken: MtnAccessToken) => {
        if (!cachedToken) {
          return this.routeToPublicPage(next);
        }

        const token = new MtnAccessToken(cachedToken);
        if (!token.isValid()) {
          return this.routeToPublicPage(next);
        }

        const licenseType = token.getCurrentUser()?.licenseType;
        if (licenseType === LicenseType.INTERNAL || licenseType === LicenseType.STANDARD) {
          return true;
        }

        return this.router.parseUrl('');
      }));
  }

  private routeToPublicPage(next: ActivatedRouteSnapshot): UrlTree {
    this.authenticationService.setRedirectUrl(getResolvedUrl(next));
    return this.router.parseUrl('');
  }
}
